/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsDesignElementColor
 */
export interface MelcoModelsDesignElementColor {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElementColor
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElementColor
     */
    manufacturer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElementColor
     */
    product_line?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElementColor
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElementColor
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsDesignElementColor
     */
    rgb?: string | null;
}

export function MelcoModelsDesignElementColorFromJSON(json: any): MelcoModelsDesignElementColor {
    return MelcoModelsDesignElementColorFromJSONTyped(json, false);
}

export function MelcoModelsDesignElementColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsDesignElementColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'product_line': !exists(json, 'product_line') ? undefined : json['product_line'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'rgb': !exists(json, 'rgb') ? undefined : json['rgb'],
    };
}

export function MelcoModelsDesignElementColorToJSON(value?: MelcoModelsDesignElementColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'manufacturer': value.manufacturer,
        'product_line': value.product_line,
        'name': value.name,
        'code': value.code,
        'rgb': value.rgb,
    };
}


